export const DEFAULT_COUNTRY = 'FR'
export const DEFAULT_CULTURE = 'fr'
export const DEFAULT_LOCALE = `${DEFAULT_CULTURE}-${DEFAULT_COUNTRY}`
export const DEFAULT_MARKET_ID = '1'
export const DEFAULT_MOMENT_LANG = 'en'
export const DEFAULT_MONEY_SETTINGS = { hideNullDecimals: true, locale: DEFAULT_LOCALE, options: {} }
